module.exports = {"510122001":"东升街道办","510122002":"西航港街道办","510122003":"华阳镇街道办","510122004":"中和街道办","510122005":"九江街道","510122006":"黄甲街道","510122007":"公兴街道","510122008":"协和街道","510122101":"太平镇","510122102":"永兴镇","510122106":"籍田镇","510122107":"正兴镇","510122108":"彭镇","510122109":"大林镇","510122110":"煎茶镇","510122111":"黄龙溪镇","510122112":"永安镇","510122115":"黄水镇","510122116":"金桥镇","510122119":"胜利镇","510122120":"新兴镇","510122121":"兴隆镇","510122122":"万安镇","510122123":"白沙镇","510122124":"三星镇","510122125":"合江镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510122.json
// module id = 2085
// module chunks = 0